import React from 'react'
import './Notfound.css';
import './Notfound.css';

export default function Notfound() {
  return (
    <>
        <div className='notfound'>
            <div className='notfound-inner'>
                <h2>404</h2>
                <p>Page not found!</p>
                <a href='/'>Back to Dashboard</a>
            </div>
        </div>
    </>
  )
}

